import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
import { exportToExcel } from '../../lib/xlsx/xlsxLibrary';
import { pulleyWeightTotal } from './PulleyList';

// import { conveyorWeightTotal } from './StructureList';

const PulleyListActionButtons = () => {
    const project = useSelector((state) => state.project.project);
    const conveyors = useSelector((state) => state.conveyors.conveyors);
    const user = useSelector((state) => state.user.user);

    if (!conveyors) return;

    const ownProject = (user && user._id) === (project && project.user._id);

    /* Excel Export를 위해 structure Data를 가공해야 한다. <- 안할 수는 없나??? */
    const exportData = dataConvert(conveyors);
    const projectName = project?.title;
    const filename = `Pulley Table_${projectName}.xlsx`;

    return (
        <PulleyListActionButtonsBlock>
            {ownProject && (
                <>
                    <StyledLink to="/write/structure" style={{ visibility: 'hidden' }}>
                        Add Structure
                        <MdAdd />
                    </StyledLink>
                    <StyledButton onClick={() => exportToExcel(exportData, filename)}>
                        Download Excel File(.xlsx)
                    </StyledButton>
                </>
            )}
        </PulleyListActionButtonsBlock>
    );
};

export default PulleyListActionButtons;

/* =================   Styles   ================== */

const PulleyListActionButtonsBlock = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
`;

const StyledLink = styled(Link)`
    padding: 0.25rem 1rem 0.35rem;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        transition: 0.3s;
    }
`;

const StyledButton = styled.button`
    padding: 0.25rem 1rem 0.35rem;
    border: 1px solid transparent;
    border-radius: 2px;
    background-color: ${palette.gray[6]};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.gray[6]};
        border: 1px solid ${palette.gray[6]};
        transition: 0.3s;
        cursor: pointer;
    }
`;

/* =================   Excel Export   ================== */
const dataConvert = (conveyors) => {
    let data = [];
    conveyors.map((conveyor) => data.push(rowGenerator(conveyor)));
    return data;
};

const rowGenerator = (conveyor) => {
    if (!conveyor.body) return;

    const { pulleys } = conveyor.body;
    if (!pulleys) {
        return;
    }

    // const array = pulleys.filter(pulley => pulley.application.includes('Drive'));
    // console.log('Drive : ', array);
    // const reArrange = array.map(item => `∅${item.diaSelected}/∅${item.brgDiaSelected*10} (${item.numberOfPulley})`)
    // console.log('reArrange : ', reArrange);

    return {
        'Conveyor\r\nID': `${conveyor.title}`,
        'Belt\r\nWidth\r\n(mm)': `${pulleys?.[0].beltWidth}`,
        Drive: `${
            pulleys
                .filter((pulley) => pulley.application.includes('Drive'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        Snub: `${
            pulleys
                .filter((pulley) => pulley.application.includes('Snub'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        Bend: `${
            pulleys
                .filter((pulley) => pulley.application.includes('Bend'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        Takeup: `${
            pulleys
                .filter((pulley) => pulley.application.includes('Takeup'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        Tail: `${
            pulleys
                .filter((pulley) => pulley.application.includes('Tail'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        HTBend: `${
            pulleys
                .filter((pulley) => pulley.application.includes('HTBend'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        LTBend: `${
            pulleys
                .filter((pulley) => pulley.application.includes('LTBend'))
                .map((item) => `∅${item.diaSelected}/∅${item.brgDiaSelected * 10} (${item.numberOfPulley})`)
                .join('\r\n') || ''
        }`,
        'Total\r\n(kg)': `${pulleyWeightTotal(pulleys)}` || '',
        // 'Total': `${conveyorWeightTotal(summary) || 0}`,
    };
};
